import apiInstance from "@/axios";

const BASE_PATH = "/companies/alimtalk-channel";

export const alimtalkChannelService = {
  async getChannelSettings() {
    const response = await apiInstance.get(`${BASE_PATH}/settings`);
    return response.data;
  },

  async createChannel(data) {
    const response = await apiInstance.post(`${BASE_PATH}`, data);
    return response.data;
  },

  async deleteChannel() {
    const response = await apiInstance.delete(`${BASE_PATH}`);
    return response.data;
  },

  async getPrimaryChannel() {
    // 왼쪽 메뉴가 매 화면 부름 — 알림톡 권한 없는 직원에게 「권한이 없습니다」를 띄우지 않게
    const response = await apiInstance.get(`${BASE_PATH}/primary`, { quietDenied: true });
    return response.data;
  },

  async getAllChannels() {
    const response = await apiInstance.get(`${BASE_PATH}/channels`);
    return response.data;
  },

  async requestToken(phoneNumber) {
    const response = await apiInstance.post(`${BASE_PATH}/request-token`, {
      phoneNumber,
    });
    return response.data;
  },

  async verifyAndRegister(phoneNumber, authToken, categoryCode) {
    const response = await apiInstance.post(
      `${BASE_PATH}/verify-and-register`,
      {
        phoneNumber,
        authToken,
        categoryCode,
      }
    );
    return response.data;
  },

  async getAllTemplates(params = {}) {
    const response = await apiInstance.get(`${BASE_PATH}/templates`, {
      params,
    });
    return response.data;
  },

  async getApprovedTemplates() {
    const response = await apiInstance.get(`${BASE_PATH}/approved-templates`);
    return response.data;
  },

  async getCertificateSettings() {
    const response = await apiInstance.get(`${BASE_PATH}/certificate-settings`);
    return response.data;
  },

  async updateCertificateSettings(data) {
    const response = await apiInstance.put(
      `${BASE_PATH}/certificate-settings`,
      data
    );
    return response.data;
  },

  async getTemplate(templateCode, channelId) {
    const params = channelId ? { channelId } : {};
    const response = await apiInstance.get(
      `${BASE_PATH}/templates/${templateCode}`,
      { params }
    );
    return response.data;
  },

  async createTemplateDirectly(channelId, data) {
    const params = channelId ? { channelId } : {};
    const response = await apiInstance.post(`${BASE_PATH}/templates`, data, {
      params,
    });
    return response.data;
  },

  async updateTemplateDirectly(templateCode, channelId, data) {
    const params = channelId ? { channelId } : {};
    const response = await apiInstance.put(
      `${BASE_PATH}/templates/${templateCode}`,
      data,
      { params }
    );
    return response.data;
  },

  async deleteTemplateDirectly(templateCode, channelId) {
    const params = channelId ? { channelId } : {};
    const response = await apiInstance.delete(
      `${BASE_PATH}/templates/${templateCode}`,
      { params }
    );
    return response.data;
  },

  async cancelTemplateInspection(channelId, templateCode) {
    const params = channelId ? { channelId } : {};
    const response = await apiInstance.delete(
      `${BASE_PATH}/templates/${templateCode}/inspect`,
      { params }
    );
    return response.data;
  },

  async getCategories() {
    const response = await apiInstance.get(`${BASE_PATH}/template-categories`);
    return response.data;
  },

  async getSendProfileCategories() {
    const response = await apiInstance.get(
      `${BASE_PATH}/sendprofile-categories`
    );
    return response.data;
  },

  async getCategoryByCode(code) {
    const response = await apiInstance.get(
      `${BASE_PATH}/template-categories/${code}`
    );
    return response.data;
  },

  async uploadTemplateImage(file) {
    const formData = new FormData();
    formData.append("file", file);
    const response = await apiInstance.post(
      `${BASE_PATH}/upload-template-image`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
    return response.data;
  },
};

export default alimtalkChannelService;
